var cx = require('classnames');

var React = require('react');

var GenericForm = require('./GenericForm');
var PasswordField = require('./PasswordField');

var PasswordRow = React.createClass({
    propTypes: {
        horizontal: React.PropTypes.number,
        label: React.PropTypes.string.isRequired
    },
    getDefaultProps: function () {
        return {
            horizontal: 3
        }
    },
    clearPassword: function () {
        this.refs.field.clearPassword();
    },
    getPassword: function () {
        return this.refs.field.getPassword();
    },
    render: function () {
        var classes = GenericForm.getClasses(this.props.horizontal);

        return <div className="form-group">
            <label className={cx(classes.label)}>{this.props.label}</label>
            <div className={cx(classes.container)}>
                <PasswordField ref="field" />
            </div>
        </div>;
    }
});
module.exports = PasswordRow;



// WEBPACK FOOTER //
// ./app/components/Form/PasswordRow.js